<template>
	<div>
		<j-card class="mb2">
			<j-accordion colorWhenClosed="bg0" :startOpen="startOpen">
				<div slot="title" class="fs4 fw7">{{ $t("policy") }}</div>
				<!-- Credentials -->
				<data-list
					slot="body"
					:label="$t('credentials')"
					:list="componentProps.root.list"
					v-on="componentHandlers"
				/>
				<!-- Facts -->
				<data-list
					:label="$t('facts')"
					slot="body"
					:list="componentProps.facts.list"
					v-on="componentHandlers"
				>
					<j-button
						type="tertiary"
						size="small"
						slot="label"
						@click="$emit('fact:add')"
						v-if="showButtons"
						>{{ $t("add_fact") }}</j-button
					>
				</data-list>
			</j-accordion>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JAccordion from "@/components/JAccordion"
import DataList from "../../DataList"

export default {
	name: "SectionPolicy",
	components: {
		JCard,
		JAccordion,
		DataList,
		JButton
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		startOpen: {
			type: Boolean,
			default: false
		},
		showButtons: {
			required: false,
			default: true
		}
	},

	methods: {}
}
</script>
